import { render, staticRenderFns } from "./part-add-or-update.vue?vue&type=template&id=84014d0e&scoped=true"
import script from "./part-add-or-update.vue?vue&type=script&lang=js"
export * from "./part-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./part-add-or-update.vue?vue&type=style&index=0&id=84014d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84014d0e",
  null
  
)

export default component.exports